var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { PureComponent } from 'react';
import { defaultProps } from './defaults';
import { addPrefixes, DivTag } from '../../Utils/AtomicTag';
import raf from '../../Utils/raf';
import { debounce } from '../../Utils/function';
var getEleAttr = function (ele) {
    if (ele && ele.getBoundingClientRect) {
        return ele.getBoundingClientRect();
    }
    console.warn('不支持getBoundingClientRect方法');
    return null;
};
var Marquee = /** @class */ (function (_super) {
    __extends(Marquee, _super);
    function Marquee(props) {
        var _this = _super.call(this, props) || this;
        _this.marquee = React.createRef();
        _this.container = React.createRef();
        _this.handleScroll = function () {
            if (_this.container && _this.container.current) {
                var rect = getEleAttr(_this.container.current);
                if (!rect) {
                    return;
                }
                if (_this.props.auto) {
                    if (rect.top < 0 && rect.bottom < 0) {
                        _this.pause();
                    }
                    else if (_this.state.pause) {
                        _this.start();
                    }
                }
            }
        };
        _this.init = function () {
            var _a = _this.props, auto = _a.auto, reversible = _a.reversible, height = _a.height, width = _a.width;
            var isHorizontal = _this.isHorizontal;
            if (_this.marquee && _this.marquee.current && _this.container.current) {
                var rect = getEleAttr(_this.marquee.current);
                if (!rect) {
                    return;
                }
                var conRect = getEleAttr(_this.container.current);
                if (!conRect) {
                    return;
                }
                if (isHorizontal) {
                    if (rect.width / 2 < conRect.width && !width) {
                        _this.container.current.style.width = (rect.width / 2).toString() + "px";
                    }
                }
                else {
                    if (rect.height / 2 < conRect.height && !height) {
                        _this.container.current.style.height = (rect.height / 2).toString() + "px";
                    }
                }
                var startPosition = reversible ? -(isHorizontal ? rect.width / 2 : rect.height / 2) : 0;
                _this.animatedPosition = startPosition;
                if (auto) {
                    _this.start();
                }
            }
        };
        _this.update = function (distance) {
            var _a = _this.props, reversible = _a.reversible, _b = _a.speed, speed = _b === void 0 ? 0.5 : _b;
            var jumpDistance = distance ? distance : speed;
            var isHorizontal = _this.isHorizontal;
            var animatedPosition = _this.animatedPosition;
            if (_this.marquee && _this.marquee.current) {
                var rect = getEleAttr(_this.marquee.current);
                if (!rect) {
                    return;
                }
                var size = isHorizontal ? rect.width : rect.height;
                var newPosition = void 0;
                var realSize = size / 2;
                if (reversible) {
                    if (jumpDistance > 0) {
                        var resetCondition = Math.abs(animatedPosition) >= jumpDistance;
                        newPosition = !resetCondition
                            ? -(realSize - Math.abs(animatedPosition) - Math.abs(jumpDistance))
                            : animatedPosition + jumpDistance;
                    }
                    else {
                        var resetCondition = Math.abs(animatedPosition) + Math.abs(jumpDistance) >= realSize;
                        newPosition = resetCondition
                            ? -(realSize - Math.abs(animatedPosition) + jumpDistance)
                            : animatedPosition + jumpDistance;
                    }
                }
                else {
                    if (jumpDistance > 0) {
                        var resetCondition = Math.abs(animatedPosition) >= realSize;
                        newPosition = resetCondition
                            ? realSize - Math.abs(animatedPosition) - Math.abs(jumpDistance)
                            : animatedPosition - jumpDistance;
                    }
                    else {
                        var resetCondition = animatedPosition > jumpDistance;
                        newPosition = resetCondition
                            ? -(realSize - Math.abs(animatedPosition) - Math.abs(jumpDistance))
                            : animatedPosition - jumpDistance;
                    }
                }
                _this.animatedPosition = newPosition;
                _this.marquee.current.style.transform = isHorizontal
                    ? "translate(" + _this.animatedPosition + "px, 0)"
                    : "translate(0, " + _this.animatedPosition + "px)";
            }
        };
        _this.animate = function () {
            var pause = _this.state.pause;
            if (pause) {
                return;
            }
            _this.animating = raf(_this.animate);
            _this.update();
        };
        _this.start = function () {
            raf.cancel(_this.animating);
            _this.setState({
                pause: false,
            }, _this.animate);
        };
        _this.pause = function () {
            _this.setState({
                pause: true,
            });
        };
        _this.mouseIn = function () {
            if (_this.props.auto) {
                _this.pause();
            }
        };
        _this.mouseOut = function () {
            if (_this.props.auto) {
                _this.start();
            }
        };
        _this.renderMarquee = function () {
            var _a = _this.props, children = _a.children, gap = _a.gap;
            var isHorizontal = _this.isHorizontal;
            var marquees = [];
            var itemCls = ['overflow-hidden', isHorizontal ? 'inline-block' : 'block'];
            var gapStyle = {
                margin: isHorizontal ? "0 " + gap / 2 + "px" : gap / 2 + "px 0",
            };
            if (children && typeof children === 'object') {
                React.Children.forEach(React.Children.toArray(children).concat(children), function (child, index) {
                    var childClassName = child.props.className
                        ? child.props.className + " legao-marquee-item"
                        : 'legao-marquee-item';
                    marquees.push(React.cloneElement(child, {
                        key: index,
                        className: childClassName + " " + addPrefixes(itemCls),
                        style: gapStyle,
                    }));
                });
            }
            return marquees;
        };
        _this.render = function () {
            var _a = _this.props, auto = _a.auto, direction = _a.direction, gap = _a.gap, height = _a.height, width = _a.width, reversible = _a.reversible, speed = _a.speed, style = _a.style, rest = __rest(_a, ["auto", "direction", "gap", "height", "width", "reversible", "speed", "style"]);
            var isHorizontal = _this.isHorizontal;
            var containerCls = ['whitespace-no-wrap', 'overflow-hidden', 'relative'];
            var containerStyle = {
                height: height && height > 0 ? height : 'inherit',
                width: width && width > 0 ? width : '100%',
            };
            var wrapperCls = ['overflow-hidden', isHorizontal ? 'inline-block' : 'block'];
            var wrapperStyle = {
                transform: isHorizontal
                    ? "translate(" + _this.animatedPosition + "px, 0)"
                    : "translate(0, " + _this.animatedPosition + "px)",
            };
            var renderMarquee = _this.renderMarquee();
            return (React.createElement(DivTag, __assign({ name: Marquee.NAME, atomics: containerCls, style: __assign(__assign({}, containerStyle), style), ref: _this.container, onMouseEnter: _this.mouseIn, onMouseLeave: _this.mouseOut }, rest),
                React.createElement(DivTag, { atomics: wrapperCls, autoPrefixedClassName: "marquee-wrapper", style: wrapperStyle, ref: _this.marquee }, renderMarquee)));
        };
        _this.animating = 0;
        _this.animatedPosition = 0;
        _this.isHorizontal = props.direction === 'horizontal';
        _this.state = {
            pause: !props.auto,
        };
        _this.handleScroll = debounce(_this.handleScroll, 200);
        return _this;
    }
    Marquee.prototype.componentDidMount = function () {
        window.addEventListener('scroll', this.handleScroll);
        this.init();
    };
    Marquee.prototype.componentWillUnmount = function () {
        window.removeEventListener('scroll', this.handleScroll);
        raf.cancel(this.animating);
    };
    Marquee.defaultProps = defaultProps;
    Marquee.NAME = 'marquee';
    Marquee.displayName = 'Marquee';
    return Marquee;
}(PureComponent));
export { Marquee };
